module.exports = __webpack_public_path__ + "assets/collegiatessoutside-regular-webfont-3d160a35ce47987bd23702c6f7b53678.svg";